import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stable',
  templateUrl: './stable.component.html',
  styleUrls: ['./stable.component.scss']
})
export class StableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
